export default "__VITE_ASSET__vV5B5_rD__"